var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin":"20px 0 0 20px"}},[_c('MyBreadcrumb')],1),_c('div',{staticClass:"site-detail"},[_c('Detail',{attrs:{"isSuper":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }